import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as s from './ExtContentSlidesList.css';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { F1 } from '@client/new/helpers/types';
import { useEffect, useRef } from 'react';
import { Button } from '@design-system/components/button/button';
import { ContentImage, ContentTree } from '../model/extras.domain';
import { animations } from '@formkit/drag-and-drop';
import { useDragAndDrop } from '@formkit/drag-and-drop/react';
import { extrasVM } from '../Extras.page';

type ContentSlidesListProps = {
  slides: ContentTree[];
  onRemove?: F1<string, void>;
  onReorder?: F1<string[], void>;
};

const SlideItem = ({
  slide,
  onRemove,
  ...p
}: {
  slide: ContentTree;
  isDragging?: boolean;
  onRemove?: F1<string, void>;
}) => {
  const extras = extrasVM.useValue();
  const slideData = extras.contentMap[slide.id] as ContentImage;
  return (
    <div className={s.card} data-label={slide.id}>
      {slideData.value.url && (
        <img
          src={slideData.value.url}
          alt={slide.id}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
      )}

      {onRemove && !p.isDragging ? (
        <Button
          onClick={() => onRemove(slide.id)}
          className={s.cardClose}
          style={{ zIndex: 10 }}
        >
          <FontAwesomeIcon icon={faClose} />
        </Button>
      ) : null}
    </div>
  );
};
export const ExtContentSlidesList = ({
  slides,
  onRemove,
  onReorder,
}: ContentSlidesListProps) => {
  const slideIdsRef = useRef<string[]>([]);

  const [parent, slideIds, setter] = useDragAndDrop<HTMLDivElement, string>(
    slides.map((slide) => slide.id),
    {
      plugins: [animations()],
      dragPlaceholderClass: s.dragPlaceholder,
      synthDragPlaceholderClass: s.dragPlaceholder,
      onDragend: () => {
        // Use ref to get the current slideIds value
        if (onReorder) onReorder(slideIdsRef.current);
      },
    },
  );

  // Update ref whenever slideIds changes
  useEffect(() => {
    slideIdsRef.current = slideIds;
  }, [slideIds]);

  useEffect(() => {
    setter(slides.map((slide) => slide.id));
  }, [slides, setter]);

  return (
    <div ref={parent} className={s.templatesList}>
      {slideIds.map((slideId) => {
        const slide = slides.find((s) => s.id === slideId);
        if (!slide) return null;

        return <SlideItem key={slide.id} slide={slide} onRemove={onRemove} />;
      })}
    </div>
  );
};
